import React from 'react';
import { Phone, Mail } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-[#0A0A0A] text-white border-t-2 border-[#FF7954]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <h3 className="text-xl font-semibold text-[#FF7954] mb-4">Contact</h3>
            <div className="space-y-4">
              <a href="tel:+33681128810" className="flex items-center hover:text-[#FF7954] transition-colors">
                <Phone size={20} className="mr-3" />
                06 81 12 88 10
              </a>
              <a href="mailto:sci.plr.60@sfr.fr?subject=Demande%20d'information%20PLR%20Park&body=Bonjour%2C%0A%0AJe%20souhaite%20obtenir%20des%20informations%20sur%20vos%20services%20de%20parking.%0A%0ACordialement%2C" className="flex items-center hover:text-[#FF7954] transition-colors">
                <Mail size={20} className="mr-3" />
                sci.plr.60@sfr.fr
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-semibold text-[#FF7954] mb-4">Horaires</h3>
            <p>Ouvert 24h/24 et 7j/7</p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 text-center">
          <p>&copy; {new Date().getFullYear()} PLR Park - Tous droits réservés</p>
        </div>
      </div>
    </footer>
  );
}